import { DateTime } from 'luxon';
import type { Option } from '@/modules/common/types/option.type.ts';
import type { GanttItem } from '@/modules/viewer/types/gantt-item.type.ts';
import { ROUTE_POINT_TYPES } from '@/modules/common/consts/route-point-types.ts';
import i18n from '@/i18n.ts';

export interface GanttLinkOption extends Option<number> {
  number: number;
  type: string;
  executor: string;
  deadline: DateTime;
}

export class GanttLinkOptionCreator {
  static createList(items: GanttItem[]): GanttLinkOption[] {
    return items.map(GanttLinkOptionCreator.create);
  }

  static create(item: GanttItem): GanttLinkOption {
    const { number, executor, deadline } = item;
    const type = ROUTE_POINT_TYPES[item.type].label;

    return {
      code: item.id,
      label: `${number}. ${i18n.global.t(type)} ${executor}`,
      type,
      executor,
      number,
      deadline,
    };
  }
}
